// @ts-check
import { Boot } from './src/Boot'

export const wrapPageElement = Boot
